import { render, staticRenderFns } from "./floatBox.vue?vue&type=template&id=5e667358&scoped=true"
import script from "./floatBox.vue?vue&type=script&lang=js"
export * from "./floatBox.vue?vue&type=script&lang=js"
import style0 from "./floatBox.vue?vue&type=style&index=0&id=5e667358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e667358",
  null
  
)

export default component.exports